<script lang="ts">
  import type { HTMLAttributes } from 'svelte/elements'

  type Props = HTMLAttributes<HTMLDivElement>

  const { children, class: className, ...rest }: Props = $props()
</script>

<div class={`container ${className}`} {...rest}>
  {@render children?.()}
</div>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
  }
</style>
